const React = require('react')
const { useEffect, useState } = require('react')
const { Container, Row, Col } = require('reactstrap')
const { useParams, useHistory } = require('react-router-dom')
const { useBlockchainData } = require('@hooks')
const { useNetworkConfig } = require('@contexts')

const { EpochDetails } = require('./details.epoch')

require('@styles/pages/block/index.css')

const Epoch = () => {
    const { epoch } = useParams()
    const history = useHistory()
    const { network } = useNetworkConfig()
    const { getEpoch, getEpochs } = useBlockchainData(network.name)

    const [loading, setLoading] = useState(false)
    const [epochData, setEpochData] = useState(null)
    const [latestEpoch, setLatestEpoch] = useState(0)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)

                const [epochResponse, epochsResponse] = await Promise.all([getEpoch(epoch), getEpochs(1, 1)])

                if (epochResponse && epochResponse) {
                    const firstSlotInEpoch = epochResponse.epoch * 32

                    if (epoch > epochsResponse.totalItems - 1) {
                        history.push(`/${network.name}/block/countdown/${firstSlotInEpoch}`)
                        return
                    }

                    setEpochData(epochResponse)
                    setLatestEpoch(epochsResponse.totalItems - 1)
                }

                setLoading(false)
            } catch (error) {
                console.error('Error fetching data:', error)
                setLoading(false)
            }
        }
        fetchData()
    }, [epoch])

    return (
        <div className='page'>
            <Container>
                <Col>
                    <Row>
                        <div className='page-header'>
                            <text className='page-title'>
                                Epoch
                                <span className='page-title-subcontent'>{` #${epoch}`}</span>
                            </text>
                            <div className='page-title-border' />
                        </div>
                    </Row>
                    <EpochDetails loading={loading} data={epochData} latestEpoch={latestEpoch} />
                </Col>
            </Container>
        </div>
    )
}

module.exports = Epoch
